import NewsItem from './NewsItem';

export default NewsItem;
export { default as MockNewsItem } from './MockNewsItem';
